var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCvButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.458 1.75V8.08333C15.458 8.50326 15.6248 8.90599 15.9218 9.20292C16.2187 9.49985 16.6214 9.66667 17.0413 9.66667H23.3747",
    stroke: "black",
    strokeOpacity: 0.78,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54134 11.25H9.12468M7.54134 17.5833H17.0413M7.54134 23.9167H17.0413M20.208 30.25H4.37468C3.53482 30.25 2.72937 29.9164 2.1355 29.3225C1.54164 28.7286 1.20801 27.9232 1.20801 27.0833V4.91667C1.20801 4.07681 1.54164 3.27136 2.1355 2.6775C2.72937 2.08363 3.53482 1.75 4.37468 1.75H15.458L23.3747 9.66667V27.0833C23.3747 27.9232 23.041 28.7286 22.4472 29.3225C21.8533 29.9164 21.0479 30.25 20.208 30.25Z",
    stroke: "black",
    strokeOpacity: 0.78,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvButton);
export default __webpack_public_path__ + "static/media/CV_Button.bc6f71fef2d8f11f5900010a84e95695.svg";
export { ForwardRef as ReactComponent };